skrilla.directive('ethereumTransfers',function() {
    return {
        templateUrl: 'directives/ethereumTransfers/ethereumTransfers.html',
        scope: {},
        controller: function ($scope, searchService, cacheService, dateService, queryService, paginationService, srefService, envService, modalService) {
            $scope.getDate = dateService.getLocal;
            $scope.pageKey = "ethereumTransfers";
            var SKRILLA_CONTRACT_ADDRESS = "0x18bDd7E5021a9137AEa8a57B5972672195E86B10";
            var STAGING_CONTRACT_ADDRESS = "0x00e8236b44369815b7b2e05907d1039cf1ba228e";

            $scope.transfers = cacheService.getObjectOrElse($scope.pageKey, []);

            $scope.reset = function () {
                $scope.query = {
                    userId: "",
                    beforeDate: "",
                    afterDate: "",
                    accountedFor: false,
                    limit: 20
                };
            }
            $scope.reset();

            $scope.getUri = function () {
              return envService.read('etherscanUrl');
            }

            $scope.search = function () {
                paginationService.resetPage($scope.pageKey);
                paginationService.pageQuery(getTransfers, $scope.pageKey);
            }
            $scope.retryTransfer = function (transfer) {
              console.log("retry", transfer)
              modalService.confirm("Are you sure you'd like to retry this transfer?",function() {
                return searchService.post("ethereum/transfers", {transferToRetry: transfer.erc20Transfer.id}, "Transfer retry requested").then(function (response) {
                  console.log(response)
                });
              });
            }

            var getTransfers = function () {
                return searchService.get("ethereum/transfers" + queryService.getQueryString($scope.query, $scope.pageKey)).then(function (response) {
                    $scope.transfers = response.data.result;
                    cacheService.registerObject($scope.pageKey, $scope.transfers);
                    paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
                });
            }

            $scope.route = function(transfer){
                var location = "";
                switch(transfer.externalReferenceType){
                    case "WITHDRAWAL":
                        location = "withdrawalDetails";
                        break;
                    case "SALE":
                        location = "saleDetails";
                        break;
                    default:
                        location = "userDetails";
                        break;
                }
                srefService.go(location, {id: transfer.externalReferenceId});
            }

            $scope.goToUser = function (user) {
                if (user !== null) {
                    srefService.go("userDetails", {id: user.id});
                }
            }

            $scope.getUser = function (user, address) {
                var name = "";
                if (user === null || user === undefined) {
                    if (address === SKRILLA_CONTRACT_ADDRESS || ((envService.get() === 'test' && address === STAGING_CONTRACT_ADDRESS))) {
                        name = "SKRILLA";
                    }
                } else {
                    name = user.username;
                }
                return name === "" ? name : " (" + name + ")";
            }
        }
    };
});